import toastr from 'react-hot-toast';
import { useMutation } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import type { SingleSparkRunFavouriteResponse } from 'types/SparkRunFavourite';
import { SPARK_RESOURCE_TYPES } from 'constants/common';
import { generateURL } from 'utilities/hooks/urlGeneration';

type mutationVariables = { email: string; token: string };

export function useValidateToken() {
  const validatePassword = ({ email, token }: mutationVariables) => {
    if (!email) {
      Promise.reject('email can not be null');
    }

    const body = {
      token: token,
      email: email,
    };

    const url = generateURL(SPARK_RESOURCE_TYPES.VALIDATE_TOKEN);
    return fetchWrapper<string>({
      url: url,
      method: 'Post',
      body: body,
    });
  };

  return useMutation('validatePassword', validatePassword);
}
